import React, { useState, useEffect } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { toast } from "react-toastify";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { apiRoutes } from "../../../../routes/api/apiRoutes";
import { useNavigate } from "react-router-dom";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";

const AddHomeBanner = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
    const [isShow, setShow] = useState();
  const navigate = useNavigate();

  const [data, setData] = useState({
    title1: "",
    title2: "",
    redirect_url: "/services",
    description: "",
    image: "",
  });

  const onClickSubmit = (e) => {
    e.preventDefault(); // ⛔ Prevent default form submission
    // IF only for file upload
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    formData.append("image", data.image); // Append the file directly
    //End Only file upload

    callAPI("post", apiRoutes.admin.homeBanner, formData);
  };


  if (responce?.data && !isShow) {
    toast.success(" Thank you! Home Banner Added Successfully");
    setShow(true);
    setTimeout(() => {
      navigate(uiRoutes.admin.homeBanner.list);
    }, 1000);
  }


  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <PageHeading
            title="Add Home Banner Input"
            subTitle="Fill out form for adding detail to Home Banner."
          />
          <div className="card p-4 shadow-sm mt-3">
            <form onSubmit={onClickSubmit}>
              <div className="row">
                {/* Row 1: Banner Heading */}
                <div className="col-12 mb-3">
                  <label htmlFor="name" className="form-label">
                    Title 1
                  </label>
                  <input
                    onChange={(e) =>
                      setData({
                        ...data,
                        title1: e.target.value,
                      })
                    }
                    type="text"
                    className="form-control py-2"
                    id="Add_Testimonial_name"
                    placeholder="Enter Banner Heading"
                  />
                  <span className="val-message">
                    {error?.message === "ValidationError" &&
                      error?.data?.title1}{" "}
                  </span>
                </div>

                <div className="col-12 mb-3">
                  <label htmlFor="name" className="form-label">
                    Title 2
                  </label>
                  <input
                    onChange={(e) =>
                      setData({
                        ...data,
                        title2: e.target.value,
                      })
                    }
                    type="text"
                    className="form-control py-2"
                    id="Add_Testimonial_name"
                    placeholder="Enter Banner Heading"
                  />
                  <span className="val-message">
                    {error?.message === "ValidationError" &&
                      error?.data?.title2}{" "}
                  </span>
                </div>
                {/* Row 2: Banner Detail */}
                <div className="col-12 mb-4">
                  <label htmlFor="note" className="form-label">
                    Description
                  </label>
                  <textarea
                    onChange={(e) =>
                      setData({
                        ...data,
                        description: e.target.value,
                      })
                    }
                    className="form-control py-2"
                    id="Add_Testimonial_Description"
                    rows="4"
                    placeholder="Enter Banner Detail"
                  ></textarea>
                  <span className="val-message">
                    {error?.message === "ValidationError" &&
                      error?.data?.description}{" "}
                  </span>
                </div>

                {/* Row 3: Banner Image */}
                <div className="col-12 mb-3">
                  <label htmlFor="name" className="form-label">
                    Image
                  </label>
                  <input
                    onChange={(e) =>
                      setData({
                        ...data,
                        image: e.target.files[0],
                      })
                    }
                    type="file"
                    className="form-control py-2"
                    id="Home_Banner_img"
                  />
                  <span className="val-message">
                    {error?.message === "ValidationError" && error?.data?.image}{" "}
                  </span>
                </div>
              </div>

              <button type="submit" className="btn btn-primary mt-3">
                Submit
              </button>
            </form>
          </div>
        </div>
      }
    />
  );
};

export default AddHomeBanner;
